export default "__VITE_ASSET__47062085__"